import React from 'react';
import { ConfigProvider, theme } from 'antd';
import { useAppearance } from '../contexts/AppearanceContext';
import { APP_BRAND_THEME } from './brandTheme';
import './app-theme.css';

export { APP_ACCENT, APP_BRAND_THEME } from './brandTheme';

// Global Settings is the baseline. Keep Ant Design's semantic palette rather
// than maintaining a second set of hex colors for custom HTML surfaces.
// Appearance layer on top of the app-wide brand layer.
export const appThemeConfig = isDark => ({
  ...APP_BRAND_THEME,
  inherit: false,
  algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
});

export const appThemeColors = token => ({
  '--app-color-background': token.colorBgLayout,
  '--app-color-surface': token.colorBgContainer,
  '--app-color-raised': token.colorBgElevated,
  '--app-color-border': token.colorBorderSecondary,
  '--app-color-input-border': token.colorBorder,
  '--app-color-text': token.colorText,
  '--app-color-muted': token.colorTextSecondary,
  '--app-color-disabled': token.colorTextDisabled,
  '--app-color-hover': token.colorFillSecondary,
  '--app-color-unread': token.colorFillTertiary,
  '--app-color-selected': token.colorPrimaryBg,
  '--app-color-accent': token.colorPrimary,
  '--app-color-accent-hover': token.colorPrimaryHover,
  '--app-color-accent-bg': token.colorPrimaryBg,
  '--app-color-link': token.colorLink,
  '--app-color-error': token.colorError,
  '--app-color-error-background': token.colorErrorBg,
  '--app-color-disabled-surface': token.colorFillTertiary,
  '--app-shadow-elevated': token.boxShadowSecondary,
});

function ThemeScope({ children, isDark, className }) {
  const { token } = theme.useToken();
  return <div className={['app-theme', className].filter(Boolean).join(' ')} data-app-theme={isDark ? 'dark' : 'light'} style={appThemeColors(token)}>{children}</div>;
}

// Opt in one screen at a time; never recolor third-party email HTML or change
// the appearance preference/state when a screen mounts.
export default function AppTheme({ children, className }) {
  const { isDark } = useAppearance();
  return <ConfigProvider theme={appThemeConfig(isDark)}><ThemeScope isDark={isDark} className={className}>{children}</ThemeScope></ConfigProvider>;
}
